import generalUpload from "../_section/upload.class";

export class userReturnToWorkLetterUpload extends generalUpload {
    constructor(request, upload, queries) {
        super(request, upload, queries);
    }
}

const template = {
    items: [
        {
            name: 'documentDate',
            label: 'Date of Letter',
            type: 'date',
        },{
            name: 'returnDate',
            label: 'Return Date',
            type: 'date',
        },
        {
            name: 'returnSalary',
            label: 'Return Salary',
            type: 'currency',
        },
        {
            name: 'returnPosition',
            label: 'Position',
            type: 'text',
        }
    ]
}

export class adminReturnToWorkLetterUpload extends userReturnToWorkLetterUpload {

    constructor(request, upload, queries) {
        super(request, upload, queries);
        this.calcValues(template)
        if (this.values.documentDate) {
            this.setDateData({
                dated: this.values.documentDate,
                expires: this.values.documentDate.add(1, 'year'),
            })
        }
    }
}
